import styled from "styled-components";
import { breakpoints } from "../../../../../../constants/media";

const Container = styled.nav`
  width: 50%;
  margin: 0px 0px 0px 0px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-content: center;
  min-width: 270px;

  button {
    width: auto;
    height: auto;
    padding: 6px 15px 6px 15px;
    margin: 0px 0px 0px 15px;
    border: 0px;
    background-color: white;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    cursor: pointer;
    background-color: var(--lightgray);
    border-radius: 20px;
    transition: 0.3s all;
  }

  .active {
    background-color: #004b85;
  }

  p {
    text-align: center !important;
    color: var(--white) !important;
    font-family: Raleway;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 13px !important;
    margin: 0px !important;
    transition: 0.1s all;
  }

  button:hover {
    background-color: var(--black);
  }

  // 1024px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet1024}) {
    margin: 20px 0px 0px 0px;
    justify-content: flex-start;
    width: 100%;
  }

  button {
    margin: 0px 15px 0px 0px;
  }
`;

export default Container;
